import { FEATURE } from '~/common/enums/feature.enum';

import { useTreatments } from '../../hooks/useTreatments';
import { HEADER_HEIGHT } from '../AppShellHeader/constants';

/**
 * TODO: Remove after old header becomes obsolete
 */
const useHeaderHeight = () => {
  const { isReady, treatments } = useTreatments([FEATURE.ENABLE_NEW_HEADER_2]);
  const isEnabled = treatments[FEATURE.ENABLE_NEW_HEADER_2]?.treatment === 'on';

  // New header
  if (!isReady || isEnabled) return HEADER_HEIGHT;

  // Old header
  return 62;
};

export default useHeaderHeight;
